export { default } from "./ComparisonShoppingTable";
